import {BaseDao} from "../BaseDao";
import {ApiHelper} from "../../apiHelper";
import {ConstantMan} from "../../constantMan";
import {Observable} from "rxjs";
import {HttpHeaders} from "@angular/common/http";

export class EncoderGroupDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.ENCODER_GROUPS, apiHelper);
    }

    public find(filters: Object): Observable<any> {
        const url: string = this.apiHelper.getServiceName() + this.getResource() + '/find';
        const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'POST', null, filters, headers);
    }

    public bulkUpdate(updates: { id: string, updates: Object }[]): Observable<any> {
        const url: string = this.apiHelper.getServiceName() + this.getResource() + '/bulk/update';
        const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'PUT', null, updates, headers);
    }

    public updateById(id: string, updates: Object): Observable<any> {
        const url: string = this.apiHelper.getServiceName() + this.getResource() + `/${id}`;
        const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'PUT', null, updates, headers);
    }

    public getByAdvertiserId(advertiserId: string): Observable<any> {
        const url: string = this.apiHelper.getServiceName() + this.getResource() + `/getByAdvertiserId/${advertiserId}`
        const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'GET', null, null, headers);
    }
}